/**
 * MEDICLOUD REST API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface EmployeeContractApiModel { 
    validityStart: string;
    validityEnd?: string | null;
    occupationId: number;
    workplaceId: number;
    companyId?: number | null;
    id: number;
    employerId: number;
}

